export class DailyStorageSummary {
    'summaryDay';
    'dailyStorageBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "summaryDay",
            "baseName": "summaryDay",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dailyStorageBytes",
            "baseName": "dailyStorageBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DailyStorageSummary.attributeTypeMap;
    }
    constructor() {
    }
}
